import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import {
    Target,
    ArrowRight,
    Zap,
    Award,
    TrendingUp,
    Sparkles,
    Clock,
    Shield,
    Store,
    Crown,
    Briefcase,
    Settings,
    Check,
    Star
} from 'lucide-react';
import api from '../utils/Api';

const additionalServices = [
    {
        //    icon: <Award className="w-5 h-5" />,
        title: "Formation au Recrutement",
        description: "Workshops et formations pour optimiser vos processus RH"
    },
    {
        //   icon: <Shield className="w-5 h-5" />,
        title: "Vérification des Références",
        description: "Service de validation des antécédents professionnels"
    },
    {
        //   icon: <TrendingUp className="w-5 h-5" />,
        title: "Conseil en Stratégie RH",
        description: "Accompagnement stratégique pour vos enjeux RH"
    },
    {
        //     icon: <Clock className="w-5 h-5" />,
        title: "Support Prioritaire 24/7",
        description: "Assistance dédiée pour vos urgences de recrutement"
    }
];

const process = [
    { step: "01", title: "Analyse de vos besoins", description: "Échange approfondi pour comprendre votre culture d'entreprise et vos exigences" },
    { step: "02", title: "Configuration de la plateforme", description: "Personnalisation de votre espace recruteur selon vos préférences" },
    { step: "03", title: "Diffusion des offres", description: "Publication de vos annonces et activation du matching IA" },
    { step: "04", title: "Sélection des candidats", description: "Tri automatique et présélection des profils les plus pertinents" }
];

const getPackMeta = (name = '') => {
    const lower = name.toLowerCase();
    //  let icon = <Briefcase className="w-7 h-7" />;
    let buttonText = "Choisir ce pack";
    let badge = null;
    let featuresList = [];

    if (lower.includes('proximité')) {
        //   icon = <Store className="w-7 h-7" />;
        //   buttonText = "Démarrer";
        featuresList = ["01 Annonce Classique", "Visibilité : 30 jours de diffusion", "Multi-diffusion : Site, App & Réseaux Sociaux", "Validité : 30 jours pour publier", "Page Entreprise personnalisée", "Rédaction professionnelle incluse"];
    } else if (lower.includes('elite')) {
        //     icon = <Crown className="w-7 h-7" />;
        //  buttonText = "Démarrer";
        featuresList = ["01 Annonce Classique", "Visibilité : 60 jours de diffusion", "CVthèque : Accès à 100 CVs", "Multi-diffusion : Site, App & Réseaux Sociaux", "Validité : 30 jours pour publier", "Page Entreprise personnalisée", "Rédaction professionnelle incluse"];
    } else if (lower.includes('essentiel')) {
        //    icon = <Target className="w-7 h-7" />;
        //  buttonText = "Choisir";
        featuresList = ["03 Annonces Premium (60 jours)", "Visibilité : 30 jours de diffusion", "Filtrage Intelligent : Questionnaire", "CVthèque : Accès à 200 CVs", "Multi-diffusion : Site, App & Réseaux Sociaux", "Validité : 60 jours (02 mois)", "Page Entreprise personnalisée", "Tri automatique des meilleurs profils", "Rédaction professionnelle incluse"];
    } else if (lower.includes('silver')) {
        //    icon = <Award className="w-7 h-7" />;
        // buttonText = "Démarrer maintenant";
        badge = "Le plus populaire";
        featuresList = ["05 Annonces Premium", "Visibilité : 60 jours de diffusion", "Filtrage Intelligent : Questionnaire", "CVthèque : Accès à 400 CVs", "Validité : 180 jours (06 mois)", "Multi-diffusion : Site, App & Réseaux Sociaux", "Page Entreprise personnalisée", "Rédaction professionnelle incluse", "Tri automatique des meilleurs profils"];
    } else if (lower.includes('gold')) {
        //     icon = <Crown className="w-7 h-7" />;
        buttonText = "Nous contacter";
        //  badge = "Recommandé";
        featuresList = ["10 Annonces Premium", "Visibilité : 60 jours de diffusion", "Filtrage Intelligent : Questionnaire", "Brief RH personnalisé", "Présélection Humaine", "Entretiens de pré-sélection inclus", "Shortlist Qualifiée (05 à 10 profils)", "CVthèque : Accès illimité", "Multi-diffusion : Site, App & Réseaux Sociaux", "Visibilité Prioritaire", "Validité : 12 mois (1 an)", "Page Entreprise personnalisée", "Rédaction professionnelle incluse"];
    }

    return { buttonText, badge, featuresList };
};

const Services = () => {
    const navigate = useNavigate();
    const [services, setServices] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => { fetchPacks(); }, []);

    const fetchPacks = async () => {
        try {
            const response = await api.get('/recruiter/packs');

            const transformedServices = response.data.map(pack => {
                const { icon, buttonText, badge, featuresList } = getPackMeta(pack.name);
                let features = featuresList;

                if (features.length === 0) {
                    if (pack.maxActiveOffers) features.push(`${pack.maxActiveOffers} Annonce(s)`);
                    if (pack.offerDurationDays) features.push(`Visibilité : ${pack.offerDurationDays} jours`);
                    features.push("Page Entreprise personnalisée");
                }

                return { _id: pack._id, title: pack.name, description: pack.description || "", features, icon, buttonText, badge };
            });

            // transformedServices.push({
            //     _id: 'flexible',
            //     title: "Solution Flexible",
            //     description: "Créez la solution de recrutement parfaitement adaptée à vos enjeux.",
            //     features: ["Devis personnalisé sur demande", "Configuration à la carte", "Accompagnement dédié"],
            //     //   icon: <Settings className="w-7 h-7" />,
            //     buttonText: "Demander un devis",
            //     badge: null,
            // });

            setServices(transformedServices);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-primary-500 transition-colors">

            {/* ── Hero ─────────────────────────────── */}
            <section className="relative py-24 overflow-hidden bg-white dark:bg-primary-600">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[350px] bg-secondary-600/10 rounded-full blur-3xl pointer-events-none" />
                <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
                    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-secondary-600 dark:text-secondary-400 mb-5">
                            <Sparkles className="w-3.5 h-3.5" />
                            Nos offres de recrutement
                        </span>
                        <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white leading-tight mb-5">
                            Une formule pour<br />
                            <span className="text-secondary-600">chaque besoin</span>
                        </h1>
                        <p className="text-lg text-gray-500 dark:text-gray-300 max-w-2xl mx-auto">
                            De la publication d'annonces au sourcing personnalisé, choisissez le pack qui correspond à votre ambition.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* ── Pricing Cards ─────────────────────── */}
            <section className="py-16 px-4">
                <div className="max-w-7xl mx-auto">
                    {loading ? (
                        <div className="flex justify-center py-20">
                            <div className="w-8 h-8 border-2 border-secondary-600 border-t-transparent rounded-full animate-spin" />
                        </div>
                    ) : (
                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {services.map((service, index) => {
                                const isFeatured = !!service.badge;
                                return (
                                    <motion.div
                                        key={service._id}
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: index * 0.07 }}
                                        className={`relative flex flex-col rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl ${isFeatured
                                            ? 'border-2 border-secondary-600 bg-white dark:bg-gray-800 shadow-lg shadow-secondary-600/20'
                                            : 'border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800'
                                            }`}
                                    >
                                        {/* Badge */}
                                        {service.badge && (
                                            <div className="absolute top-4 right-4 z-10 flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-secondary-600 text-primary-500">
                                                <Star className="w-3 h-3" />
                                                {service.badge}
                                            </div>
                                        )}

                                        {/* Header band — gray gradient */}
                                        <div className="bg-gradient-to-br from-gray-700 to-gray-600 dark:from-gray-900 dark:to-gray-700 p-6 flex items-center gap-4 min-h-[100px]">
                                            {/* <div className="w-12 h-12 rounded-xl bg-secondary-600/20 flex items-center justify-center text-secondary-400 flex-shrink-0">
                                                {service.icon}
                                            </div> */}
                                            <div>
                                                <h3 className="text-lg font-bold text-white leading-tight">{service.title}</h3>
                                                {service.description && (
                                                    <p className="text-sm text-gray-300 mt-0.5 line-clamp-2">{service.description}</p>
                                                )}
                                            </div>
                                        </div>

                                        {/* Features + CTA */}
                                        <div className="flex flex-col flex-1 p-6 gap-4">
                                            <ul className="space-y-2.5 flex-1">
                                                {service.features.map((feature, idx) => (
                                                    <li key={idx} className="flex items-start gap-2.5 text-sm text-gray-600 dark:text-gray-300">
                                                        <span className="mt-0.5 w-4 h-4 rounded-full flex-shrink-0 flex items-center justify-center bg-secondary-600/15">
                                                            <Check className="w-2.5 h-2.5 text-secondary-600 dark:text-secondary-400" />
                                                        </span>
                                                        {feature}
                                                    </li>
                                                ))}
                                            </ul>

                                            {/* CTA — always at bottom */}
                                            <motion.button
                                                onClick={() => navigate('/contact')}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                                className={`mt-4 w-full py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 transition-all ${isFeatured
                                                    ? 'bg-secondary-600 hover:bg-secondary-400 text-gray-900'
                                                    : 'bg-gray-800 hover:bg-gray-700 text-white dark:bg-gray-700 dark:hover:bg-gray-600'
                                                    }`}
                                            >
                                                {service.buttonText}
                                                <ArrowRight className="w-4 h-4" />
                                            </motion.button>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>

            {/* ── Process ───────────────────────────── */}
            <section className="py-20 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800">
                <div className="max-w-6xl mx-auto px-6">
                    <div className="text-center mb-14">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">Comment ça marche ?</h2>
                        <p className="text-gray-500 dark:text-gray-400">Un processus simple en 4 étapes</p>
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {process.map((item, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="relative text-center"
                            >
                                <div className="w-14 h-14 rounded-full bg-secondary-600/10 text-secondary-600 dark:text-secondary-400 text-xl font-bold flex items-center justify-center mx-auto mb-4 border border-secondary-600/30">
                                    {item.step}
                                </div>
                                <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">{item.title}</h3>
                                <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{item.description}</p>
                                {index < process.length - 1 && (
                                    <div className="hidden lg:block absolute top-7 left-full w-full h-px bg-gradient-to-r from-secondary-600/40 to-transparent" />
                                )}
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── Additional Services ───────────────── */}
            <section className="py-20 border-t border-gray-100 dark:border-gray-800">
                <div className="max-w-6xl mx-auto px-6">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-3">Services additionnels</h2>
                        <p className="text-gray-500 dark:text-gray-400">Des options pour aller encore plus loin</p>
                    </div>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                        {additionalServices.map((service, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.05 }}
                                className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-5 hover:border-secondary-400 hover:shadow-md transition-all"
                            >
                                {/* <div className="w-10 h-10 rounded-lg bg-secondary-600/10 text-secondary-600 dark:text-secondary-400 flex items-center justify-center mb-4">
                                    {service.icon}
                                </div> */}
                                <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1.5">{service.title}</h3>
                                <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">{service.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── CTA ───────────────────────────────── */}
            <section className="py-20 bg-gradient-to-br from-gray-800 to-gray-900">
                <div className="max-w-3xl mx-auto px-6 text-center">
                    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
                        <h2 className="text-4xl font-bold text-white mb-4">
                            Prêt à transformer votre recrutement ?
                        </h2>
                        <p className="text-gray-400 mb-10">
                            Commencez dès aujourd'hui et recrutez plus vite, plus intelligemment.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <motion.button
                                onClick={() => navigate('/register')}
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                className="px-8 py-3.5 bg-secondary-600 hover:bg-secondary-400 text-primary-500 rounded-xl font-semibold inline-flex items-center gap-2 transition-all"
                            >
                                <Zap className="w-4 h-4" />
                                Commencer maintenant
                            </motion.button>
                            <motion.button
                                onClick={() => navigate('/about')}
                                whileHover={{ scale: 1.04 }}
                                whileTap={{ scale: 0.97 }}
                                className="px-8 py-3.5 border border-white/20 text-white rounded-xl font-semibold hover:bg-white/5 transition-all"
                            >
                                En savoir plus
                            </motion.button>
                        </div>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Services;
